module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "zcglIndex"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.showjjgk),
      expression: "!$route.meta.showjjgk"
    }]
  }, [_c('div', {
    staticClass: "tab"
  }, _vm._l((_vm.jjfl), function(item, index) {
    return _c('a', {
      class: {
        active: _vm.tabindex === index
      },
      on: {
        "click": function($event) {
          _vm.tabindex = index
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "cplist"
  }, _vm._l((_vm.jjfl), function(item, index) {
    return (_vm.tabindex === index) ? _c('div', _vm._l((item.list), function(jj) {
      return _c('div', {
        staticClass: "jjlist",
        on: {
          "click": function($event) {
            _vm.jjgk(jj.id)
          }
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_c('div', {
        staticClass: "i"
      }, [_vm._v("i")]), _vm._v("\n            " + _vm._s(jj.name) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "ljnh",
        class: {
          green: parseFloat(jj.ljnh) < 0
        }
      }, [_c('p', [_vm._v(_vm._s(parseFloat(jj.ljnh).toFixed(2)) + "%")]), _vm._v(" "), _c('p', {
        staticClass: "xz"
      }, [_vm._v("累计年化收益")])]), _vm._v(" "), _c('div', {
        staticClass: "xx"
      }, [_c('p', {
        staticClass: "bule"
      }, [_vm._v("单位净值：" + _vm._s(jj.dwjz))]), _vm._v(" "), _c('p', [_vm._v("成立日期："), _c('span', [_vm._v(_vm._s(jj.clrq))])]), _vm._v(" "), _c('p', [_vm._v("更新日期："), _c('span', [_vm._v(_vm._s(jj.gxrq))])])]), _vm._v(" "), _c('hr')])
    })) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "gglist"
  }, [_c('div', {
    staticClass: "listTitle"
  }, [_vm._v("资产管理公告")]), _vm._v(" "), _c('List', {
    attrs: {
      "list": _vm.gglist,
      "name": "zcgl",
      "ShowTime": true,
      "count": 5
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ShowMore",
    staticStyle: {
      "display": "inherit"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'zcgl',
        params: {
          nr: 'gglist'
        }
      }
    }
  }, [_vm._v("点击查看更多")])], 1)], 1)]), _vm._v(" "), _c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.meta.showjjgk),
      expression: "$route.meta.showjjgk"
    }],
    staticClass: "min-height"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48433cc9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/zcgl/page/index.vue
// module id = 884
// module chunks = 2